import {metadaApi} from '@dms/api/base';

import {
  DeleteTransferOrderVariantRequest,
  DeleteTransferOrderVariantRequestSchema,
  DeleteTransferOrderVariantResponse,
  DeleteTransferOrderVariantResponseSchema,
  GetTransferOrderVariantRequest,
  GetTransferOrderVariantRequestSchema,
  GetTransferOrderVariantResponse,
  GetTransferOrderVariantResponseSchema,
  GetTransferOrderVariantsRequest,
  GetTransferOrderVariantsRequestSchema,
  GetTransferOrderVariantsResponse,
  GetTransferOrderVariantsResponseSchema,
  PatchTransferOrderVariantRequest,
  PatchTransferOrderVariantRequestSchema,
  PatchTransferOrderVariantResponse,
  PatchTransferOrderVariantResponseSchema,
  PostTransferOrderVariantRequest,
  PostTransferOrderVariantRequestSchema,
  PostTransferOrderVariantResponse,
  PostTransferOrderVariantResponseSchema,
} from './types';

export const metadaWarehouseTransferOrderVariantApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getTransferOrderVariants: build.query<
      GetTransferOrderVariantsResponse,
      GetTransferOrderVariantsRequest
    >({
      query: (queryArg) => ({
        url: 'warehouse/v1/transfer-order-variant',
        method: 'GET',
        params: {authorizationProfileId: queryArg.authorizationProfileId},
        queryArg,
      }),
      providesTags: ['transferOrderVariants'],
      extraOptions: {
        requestSchema: GetTransferOrderVariantsRequestSchema,
        responseSchema: GetTransferOrderVariantsResponseSchema,
      },
    }),
    getTransferOrderVariant: build.query<
      GetTransferOrderVariantResponse,
      GetTransferOrderVariantRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/transfer-order-variant/${queryArg.transferOrderVariantId}`,
        method: 'GET',
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'transferOrderVariants', id: queryArg.transferOrderVariantId},
      ],
      extraOptions: {
        requestSchema: GetTransferOrderVariantRequestSchema,
        responseSchema: GetTransferOrderVariantResponseSchema,
      },
    }),
    postTransferOrderVariant: build.mutation<
      PostTransferOrderVariantResponse,
      PostTransferOrderVariantRequest
    >({
      query: (queryArg) => ({
        url: 'warehouse/v1/transfer-order-variant',
        method: 'POST',
        body: queryArg,
        queryArg,
      }),
      invalidatesTags: ['transferOrderVariants'],
      extraOptions: {
        requestSchema: PostTransferOrderVariantRequestSchema,
        responseSchema: PostTransferOrderVariantResponseSchema,
      },
    }),
    patchTransferOrderVariant: build.mutation<
      PatchTransferOrderVariantResponse,
      PatchTransferOrderVariantRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/transfer-order-variant/${queryArg.transferOrderVariantId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'transferOrderVariants', id: queryArg.transferOrderVariantId},
      ],
      extraOptions: {
        requestSchema: PatchTransferOrderVariantRequestSchema,
        responseSchema: PatchTransferOrderVariantResponseSchema,
      },
    }),
    deleteTransferOrderVariant: build.mutation<
      DeleteTransferOrderVariantResponse,
      DeleteTransferOrderVariantRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/transfer-order-variant/${queryArg.transferOrderVariantId}`,
        method: 'DELETE',
        queryArg,
      }),
      invalidatesTags: ['transferOrderVariants'],
      extraOptions: {
        requestSchema: DeleteTransferOrderVariantRequestSchema,
        responseSchema: DeleteTransferOrderVariantResponseSchema,
      },
    }),
  }),
});

export const {
  useGetTransferOrderVariantsQuery,
  useGetTransferOrderVariantQuery,
  usePostTransferOrderVariantMutation,
  usePatchTransferOrderVariantMutation,
  useDeleteTransferOrderVariantMutation,
} = metadaWarehouseTransferOrderVariantApi;
